import {
    Component,
    EventEmitter,
    Input,
    Output
} from '@angular/core';
import { PaymentService } from '../../../services/payment.service';

@Component({
    selector: 'payment-resume-pay-button-contracts',
    templateUrl: './payment.resume.pay-button.contracts.component.html',
    styleUrls: ['../../../payment.component.scss']
})
export class PaymentResumePayButtonContractsComponent {
    @Output('signed') signed: EventEmitter<Array<any>> = new EventEmitter();
    @Output('refused') refused: EventEmitter<Array<any>> = new EventEmitter();
    @Input('contracts') contracts = [];

    constructor(public paymentService: PaymentService) {
    }

    public emit(event) {
        const isChecked = !!event.target.checked;
        const contract = this.contracts.find((contract) => contract.id == event.target.id.replace('pay-button-contract-', ''));
        if (isChecked) {
            this.signed.emit(contract);
        } else {
            this.refused.emit(contract);
        }
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src2078029388/src/src/app/payment/resume/pay-button/contracts/payment.resume.pay-button.contracts.component.ts